// 亦中学子
<template>
  <div class="campusLife">
    <TabPageLayout activeCode="xiaoyuanshenghuo" :activeId="activeTabId" v-if="activeTabId">
      <div class="container internationalCourse" v-for="item in blockArticles" :key="item.id">
        <div class="div_mod div_mod2 div_mod1">
          <div class="div_tit">
            <h2>{{ item.title }}</h2>
          </div>
        </div>

        <div class="news">
          <div class="news_list">
            <ul>
              <li v-for="article in item.articles" :key="article.id">
                <ArticleCard :article="article" activeCode="xiaoyuanshenghuo" />
              </li>
            </ul>
          </div>
        </div>

        <el-pagination
          class="div_page"
          background
          layout="prev, pager, next"
          prev-text="上一页"
          next-text="下一页"
          :total="+total"
          :current-page="+currentPage"
          :page-size="pageSize"
          :hide-on-single-page="true"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </TabPageLayout>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TabPageLayout from './components/TabPageLayout.vue'
import { useGetCategories } from './utils/useGetCategories'
import portalApi from '../../../lvya-common/src/api/eos/portal'
import ArticleCard from './components/ArticleCard.vue'

export default {
  components: { TabPageLayout, ArticleCard },
  computed: {
    ...mapState({
      nav: (state) => state.yzsyStore.nav,
    }),
    typeId() {
      return (
        this.nav?.find((item) => item.code === 'xiaoyuanshenghuo')?.stypes[2]
          ?.id || undefined
      )
    },
    schoolYear() {},
    activeTabId() {
      return this.typeId
    },
  },
  data() {
    return {
      blocks: [],
      blockArticles: [],
      total: 0,
      currentPage: 1,
      pageSize: 9999,
      arr1: [
        { title: '第一个', id: '11' },
        { title: '第二个', id: '22' },
      ],
      data: [
        [
          { title: '文章1', id: '1111', typeid: '11' },
          { title: '文章2', id: '2222', typeid: '11' },
        ],
        [
          { title: '文章1', id: '1111', typeid: '22' },
          { title: '文章2', id: '2222', typeid: '22' },
        ],
      ]
    }
  },
  methods: {
    async getBlocks() {
      const categories = await useGetCategories(this.typeId)
      console.log({ categories })
      this.blocks = categories.list
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.getArticles()
    },
    async getArticles() {
      // const portalSchoolInfo = JSON.parse(
      //   localStorage.getItem('portalSchoolInfo')
      // )
      const articles = []
      for (const block of this.blocks) {
        console.log(block, 'block')
        let reqData = {
          noSchoolId: true,
          schoolId: '7',
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          typeId: block.id,
          isContent: 'Y',
          applyState: 'Y',
        }
        let resData = await portalApi.getArtsByPage(reqData)
        // console.log(resData, 'resData')
        articles.push(resData?.list)
        // console.log(articles, 'articles')
        this.total = resData.total
      }
      // this.blockArticles = articles
      // 合并成一个嵌套结构的数组
      const mergedArray = this.blocks?.map((category, index) => ({
        ...category,
        articles: articles[index],
      }))
      this.blockArticles = mergedArray
      console.log(mergedArray, 'mergedArray')
    },
  },
  async mounted() {
    await this.getBlocks()
    await this.getArticles()
  },
}
</script>

<style lang="less" scoped>
@import "./style/common.css";
@import "./style/global.css";
@import "./style/campusLife.css";
</style>

